import { useNavigate } from 'react-router-dom';
import { ApiRequestError } from '../lib/api.js';
import { useChildPicker } from '../lib/session.js';
import { Avatar } from '../art/Avatar.js';

/**
 * The first thing a child sees. No text to read beyond their own name, one tap
 * to get going.
 *
 * This screen is reachable without signing in, so it shows the DRAWN character
 * only - never a child's photo. That is enforced on the server too: the picker
 * endpoint does not return one. The list itself only comes back on a device a
 * parent has signed in on; anywhere else the child is sent to a grown-up.
 */
export function ChildPicker() {
  const navigate = useNavigate();
  const { data, isPending, error } = useChildPicker();
  const needsGrownUp = error instanceof ApiRequestError && error.status === 401;

  return (
    <main className="screen">
      <h1>Who&rsquo;s playing?</h1>

      {isPending && <p>Just a moment&hellip;</p>}
      {needsGrownUp && (
        <p className="gentle-note">
          A grown-up needs to sign in on this device once &mdash; tap the button below.
        </p>
      )}
      {error && !needsGrownUp && (
        <p className="gentle-note">We can&rsquo;t reach the quest right now. Try again soon.</p>
      )}

      {data?.length === 0 && (
        <p className="gentle-note">
          Nobody is set up yet. A grown-up can add you &mdash; tap the button below.
        </p>
      )}

      <div className="profiles">
        {data?.map((child) => (
          <button
            key={child.id}
            type="button"
            className="profile-card"
            onClick={() => navigate(`/pin/${child.id}`)}
          >
            <Avatar config={child.avatarConfig} size={120} title={child.nickname} />
            {child.nickname}
          </button>
        ))}
      </div>

      <button type="button" className="btn btn--quiet" onClick={() => navigate('/parent')}>
        Grown-ups
      </button>
    </main>
  );
}
